import React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import BaseListingRendererWithPlugins from 'nav/expanded/BaseListingRendererWithPlugins';
import {
  ColumnAccessorKey,
  ColumnConfiguration,
  ListingRendererType,
} from 'nav/expanded/ListingRendererConstants';
import * as TestDefinitionContextMenu from 'sample-tests/search/TestDefinitionContextMenu';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import {TABLE_ROW_BODY_HEIGHT} from 'ui-library/scrollable/ScrollableTableConstants';
import {BasicEvent} from 'util/Types';

import {TestDefinitionListingGraphQL} from '../../../graphql-fragments/sample_tests/__generated/TestDefinitionListingGraphQL';

export default class TestDefinitionListingRenderer extends BaseListingRendererWithPlugins<ListingRendererType.TEST_DEFINITION> {
  listingRendererType = ListingRendererType.TEST_DEFINITION;

  renderIcon(): JSX.Element {
    return <BenchlingIcon icon={ModelTypeConstants.TEST_DEFINITION} className="scrollableTable-cell-icon" />;
  }

  getNonPluginColumnConfigurations(
    items: Array<TestDefinitionListingGraphQL>
  ): Array<ColumnConfiguration<TestDefinitionListingGraphQL>> {
    const columns: Array<ColumnConfiguration<TestDefinitionListingGraphQL>> = [
      {
        column: {
          accessorKey: ColumnAccessorKey.NAME,
          header: 'Name',
          flexGrow: 1,
          isSortable: true,
          sortKey: 'name',
        },
        render: (item) => item.name,
      },
      {
        column: {accessorKey: ColumnAccessorKey.DESCRIPTION, header: 'Description', flexGrow: 1},
        render: (testDef: TestDefinitionListingGraphQL) => testDef.description,
      },
    ];

    return columns;
  }

  getNonPluginRowContentHeight(item: TestDefinitionListingGraphQL): number {
    return TABLE_ROW_BODY_HEIGHT;
  }

  openContextMenu(item: TestDefinitionListingGraphQL, e: BasicEvent, extras: unknown): void {
    TestDefinitionContextMenu.open(e.nativeEvent, item);
  }
}
